
    import { defineComponent, ref, watch } from 'vue';
    import request from '@/utils/request'
    export default defineComponent({
        name:'ui-select',
        props: {
            value: {default: ''},
            url: {type: String, default: ''},
            urlencode: {type: Boolean, default: false},
            filterable: {type: Boolean, default: false},
            remote: {type: Boolean, default: false},
            multiple: {type: Boolean, default: false},
            label: {type: String, default: ''},
            feidId: {default: ''},
            feidText: {default: ''},
            search: {type: Object, default: () => {}} // 搜索条件
        },
        setup(props,ctx){
            const selectDataList:any = ref([])
            const valueSelect = ref()
            function getList():void{
                request({
                    url:props.url.toString(),
                    method: 'post',
                }).then(data => {
                    selectDataList.value = data.data
                })
            }
            function change (val) {
                ctx.emit('oninput', val)
            }
            function changes (val) {
                console.log(val)
                ctx.emit('change', val)
            }
            getList()
            return{
                selectDataList,
                valueSelect,
                change,
                changes
            }
        }
    })
